import React from 'react';

export default ({
	EN: {
		appointmentStatus: (success, usingClick) => {
			if (!success) {
				return `We're Sorry.`;
			}
			return usingClick ? 'Appointment Confirmed' : 'Appointment Requested';
		},
		confirmationNo: (success, num) => success ? `Confirmation #${num}` : 'The scheduling system is temporarily down.',
		thankYou: (success, usingClick) => {
			if (!success) {
				return 'Our engineers are working hard to resolve the issue.';
			}
			return (usingClick ?
				'Thank you for scheduling an appointment with AiM.' :
				'Your appointment has NOT yet been set.  We will contact you within 24 hours to confirm this date or to offer an alternative.  You can also contact us immediately by calling our dispatch office at 866-621-9123.  Please be advised you may experience a longer wait time as we want to ensure each customer’s scheduling needs are met. We understand how valuable your time is and we thank you for your patience.');
		},
		youWillReceiveEmail: (success, email) => success ?
			(<span>You will receive an email confirmation shortly at <span className='email'>{email}</span>.</span>) :
			'Please start over again. If the issue persists, please report the issue and we will contact you as soon as possible.',
		youCanCloseThisWindow: 'You can now close this window.',
		startOver: 'Start over',
		pageTitle: 'Confirmation'
	},
	ES: {
		appointmentStatus: (success, usingClick) => {
			if (!success) {
				return 'Lo Sentimos';
			}
			return usingClick ? 'Cita Confirmada' : 'Solicitud de cita';
		},
		confirmationNo: (success, num) => success ? `Número de Confirmación #${num}` : 'El sistema de programación está temporalmente inactivo.',
		thankYou: (success, usingClick) => {
			if (!success) {
				return 'Nuestros ingenieros están trabajando duro para resolver el problema';
			}
			return (usingClick ?
				'Gracias por programar una cita con AiM.' :
				'Su cita aún NO se ha establecido. Nos pondremos en contacto con usted dentro de las 24 horas para confirmar esta fecha o para ofrecerle una alternativa. También puede contactarnos inmediatamente llamando a nuestra oficina de despacho al 866-621-9123. Tenga en cuenta que puede experimentar un mayor tiempo de espera, ya que queremos asegurarnos de que se cumplan las necesidades de programación de cada cliente. Entendemos lo valioso que es su tiempo y le agradecemos su paciencia.');
		},
		youWillReceiveEmail: (success, email) => success ?
			(<span>Usted recibirá un correo electrónico de confirmación en breve en <span className='email'>{email}</span>.</span>) :
			'Por favor empezar de nuevo. Si el problema persiste, comuníquese el problema y nos pondremos en contacto con usted lo antes posible.',
		youCanCloseThisWindow: 'Ahora puede cerrar esta ventana.',
		startOver: 'Comenzar de nuevo',
		pageTitle: 'Confirmación'
	}
});
